export const login = (value, type = 0) => {
    let isLogin = $("#isLogin").val();
    if ( isLogin == false ){
        window.location.href = "/login";
        return "false";
    }
    return "true";
};